import { Autocomplete, FormControl, TextField } from "@mui/material";
import { LabelWithControl } from "components/common/LabelControl";
import { useSelector } from "react-redux";
import { useMemo } from "react";

export const StoreSelector = ({ storeId, onChange }) => {
  const locationResponse = useSelector((state) => state.locations.locationResponse);

  const storeOptions = useMemo(() => {
    if (!locationResponse || !Array.isArray(locationResponse)) return [];
    return locationResponse
      .filter((loc) => loc.channel.toLowerCase() === "supplychain" && loc.locationType === "Store")
      .map((loc) => ({
        value: loc.locationId,
        label: `${loc.locationId} - ${loc.locationName}`,
      }));
  }, [locationResponse]);

  const selectedOption = storeOptions.find((o) => o.value === storeId) || null;

  return (
    <LabelWithControl label="Store" labelId="storeId">
      <FormControl fullWidth size="small">
        <Autocomplete
          id="storeId"
          size="small"
          options={storeOptions}
          getOptionLabel={(option) => option.label || ""}
          value={selectedOption}
          onChange={(e, newValue) => onChange(newValue ? newValue.value : "")}
          filterOptions={(options, { inputValue }) => {
            const input = inputValue.toLowerCase();
            return options.filter((o) => o.label.toLowerCase().includes(input));
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Search by Store ID or Name"
              className="dropDownValue locationDropDownValue"
            />
          )}
          className="autoCompleteStyle"
          isOptionEqualToValue={(option, value) => option.value === value.value}
        />
      </FormControl>
    </LabelWithControl>
  );
}    
